<template>
  <div id="app">
    <transition :name="transitionName" >
      <router-view />
    </transition>
    <audio id="myAudio" ref="bgmp3" src="./assets/mp3/bg.mp3" loop muted></audio>
    <div
      :class="music_on?'music_box music_rotate':'music_box'"
      :style="{backgroundImage: musicImgUrl, backgroundSize:'cover',backgroundRepeat:'no-repeat',backgroundPosition:'center'}"
      @click="mp3Control"
    ></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      transitionName: "slide-up",
      music_on: true,
      musicImgUrl: "url(" + require("./assets/images/music_on.png") + ")"
    };
  },
  watch: {
    $route(to, from) {
      console.log(from.path);
      if (to.path == "/Result") {
        this.transitionName = "slide-result";
      }
    }
  },
  methods: {
    mp3Control() {
      if (this.music_on) {
        this.$refs.bgmp3.pause();
        this.music_on = false;
        this.musicImgUrl =
          "url(" + require("./assets/images/music_off.png") + ")";
      } else {
        this.$refs.bgmp3.play();
        this.music_on = true;
        this.musicImgUrl =
          "url(" + require("./assets/images/music_on.png") + ")";
      }
    }
  },
  mounted() {
    if (this.music_on) {
      this.musicImgUrl = "url(" + require("./assets/images/music_on.png") + ")";
    } else {
      this.musicImgUrl =
        "url(" + require("./assets/images/music_off.png") + ")";
    }
    setTimeout(() => {
      $("#myAudio")[0].muted = false;
      $("#myAudio")[0].play();
    },0);
    document.addEventListener(
      "WeixinJSBridgeReady",
      function() {
        document.getElementById("myAudio").play();
      },
      false
    );
  }
};
</script>
<style lang="stylus">
@font-face {
  font-family: 'PH';
  src: url('./commen/ALIBABA-PUHUITI-REGULAR.TTF');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'PH-M';
  src: url('./commen/ALIBABA-PUHUITI-MEDIUM.TTF');
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: PH, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html, body, div, ul, li, p, input, span, h1, h2, h3 {
  padding: 0;
  margin: 0;
  user-select: none;
}

li {
  list-style: none;
}

html, body {
  width: 100%;
  height: 100%;
}

.main-wrapper {
  position: absolute;
  width: 100%;
  height: 12rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.slide-up-enter-active {
  transition: all 0.2s linear;
}

.slide-up-leave-active {
  transition: all 0.5s linear;
}

.slide-up-enter {
  transform: translateY(100%);
  opacity: 1;
}

.slide-up-leave-to {
  transform: translateY(-100%);
  opacity: 1;
}

.slide-result-enter-active {
  transition: all 0s ease;
}

.slide-result-leave-active {
  transition: all 0s ease;
}

.slide-result-enter {
  // transform: translateY(100%);
  opacity: 0;
}

.slide-result-leave-to {
  // transform: translateY(-100%);
  opacity: 0;
}

/* 音乐 */
.music_box {
  width: 0.73rem;
  height: 0.73rem;
  position: absolute;
  top: 0.5rem;
  right: 0.2rem;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
  background-position: bottom center;
  background-repeat: no-repeat;
  z-index: 99;
}

.music_rotate {
  transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  /* IE 9 */
  -moz-transform: rotate(0deg);
  /* Firefox */
  -webkit-transform: rotate(0deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(0deg);
  animation: musicFlash 3s linear 0s normal infinite forwards;
  -webkit-animation: musicFlash 3s linear 0s normal infinite forwards;
}

@keyframes musicFlash {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes musicFlash {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
